import { Component, OnDestroy, OnInit, forwardRef, DoCheck } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { AsyncDataService } from '../../../_infrastructure/AsyncData/AsyncDataService';

import { WorkflowComponentNew } from '../../workflow-new.component';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { Subscription } from 'rxjs';
import { PreFilledProperty } from '../../../_infrastructure/Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
@Component({
  selector: 'sender-contacts',
  templateUrl: './sender-contacts.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => SenderContactsComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class SenderContactsComponent implements OnInit, OnDestroy {
   
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];

  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins ) 
  public get cardData(): models.SenderContactsVM {
    return this._cardData;
  }
  public set cardData(value: models.SenderContactsVM) {
    this._cardData = value;
    this.firstOnCardChanged();
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.SenderContactsVM = {} as models.SenderContactsVM;

  public parentWorkflow: WorkflowComponentNew;
  private mainSubscription = new Subscription();
  public preFilledProperties: PreFilledProperty[] = [];
  private isFirstChange: boolean = true;
  public isCommonDataLoaded: boolean = false;
  public isServiceOrFunerary: boolean;

  public mobilePattern: string = "^9\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";
  public landlinePattern: string = "^(2|3)\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";

  constructor(private asyncDataService: AsyncDataService, private commonDataService: CommonDataService) {
    const domainCodes = [DomainCodes.country];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe((domains: models.DomainVM[]) => {
        this.countries = domains.find(el => el.domainCode === DomainCodes.country).dimensions;
        this.isCommonDataLoaded = true;
      })
    )
   
  }

  ngOnInit(): void {
    this.isServiceOrFunerary = this.parentWorkflow.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() == 'true';
  }

  firstOnCardChanged(): void {
    if (this.isFirstChange) {
      this.isFirstChange = false;
      this.preFilledProperties.push({ name: "countryCode", preFilledValue: this.cardData.countryCode, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.countryCode) });
      this.preFilledProperties.push({ name: "address", preFilledValue: this.cardData.address, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.address) });
      this.preFilledProperties.push({ name: "postalCodeFirst", preFilledValue: this.cardData.postalCodeFirst, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.postalCodeFirst) });
      this.preFilledProperties.push({ name: "postalCodeFull", preFilledValue: this.cardData.postalCodeFull, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.postalCodeFull) });
      this.preFilledProperties.push({ name: "postalCodeLast", preFilledValue: this.cardData.postalCodeLast, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.postalCodeLast) });
      this.preFilledProperties.push({ name: "locality", preFilledValue: this.cardData.locality, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.locality) });
      this.preFilledProperties.push(
        {
          name: "mobilePhone",
          preFilledValue: this.cardData.mobilePhone,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.mobilePhone)
        });

    }
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

  private onCardDataChanged() {

    this.cardData.address = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.address;
    this.cardData.countryCode = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.countryCode;
    this.cardData.locality = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.locality;
    this.cardData.postalCodeFirst = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.postalCodeFirst;
    this.cardData.postalCodeLast = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.postalCodeLast;
    this.cardData.postalCodeFull = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.postalCodeFull;
    this.cardData.telephone = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.telephone;
    this.cardData.email = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.email;
    this.cardData.mobilePhone = this.parentWorkflow.workflowInstance.StepSender?.SenderContacts?.mobilePhone;
  }

  public onCountryChanged() {
    //clearRelated] = "{ll;model : this.cardData , propsToReset : ['postalCodeFirst','postalCodeLast','postalCodeFirst','postalDesignation']}
    this.cardData.postalCodeFirst = null;
    this.cardData.postalCodeLast = null;
    this.cardData.postalCodeFull= null;
    this.cardData.postalDesignation = null;
    this.preFilledProperties.find(el => el.name == "postalCodeFirst").hasValue = false;
    this.preFilledProperties.find(el => el.name == "postalCodeLast").hasValue = false;
    this.preFilledProperties.find(el => el.name == "postalCodeFull").hasValue = false;
    this.preFilledProperties.find(el => el.name == "postalDesignation").hasValue = false;
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }
  onPostalCodeChanged() {
    if (this.cardData.postalCodeFirst?.length == 4 && this.cardData.postalCodeLast?.length == 3) {
      try {
        this.asyncDataService.getPostalCodeDesignation(this.cardData.postalCodeFirst, this.cardData.postalCodeLast).subscribe(designation => {
          this.cardData.postalDesignation = designation;
          this.cardData.postalCodeFull = this.cardData.postalCodeFirst + "-" + this.cardData.postalCodeLast;
        }, error => {
          console.log(error);
        });
      }
      catch (e) {
        console.log(e);
      }
    }
  }
}
